<template>
  <div class="summary-container">
    <!-- Title -->
    <div>
      <h2 style="font-weight: 700; font-size: 20px;">
        {{ appointment.subject }}
      </h2>
    </div>
    <!-- Date -->
    <div class="d-flex pb-1">
      <base-text
        semibold
        class="summary-text"
      >
        Date:
      </base-text>
      &nbsp;
      <base-text class="summary-text">
        {{ appointment.start_date | nicedate('custom', 'dddd, MMMM DD, YYYY') }}
      </base-text>
    </div>
    <!-- Time -->
    <div class="d-flex pb-1">
      <base-text
        semibold
        class="summary-text"
      >
        Time:
      </base-text>
      &nbsp;
      <base-text class="summary-text">
        {{ appointment.start_date | nicedate('custom', 'h:mm A') }} to
        {{ appointment.end_date | nicedate('custom', 'h:mm A') }}
      </base-text>
    </div>
    <!-- Appointment Link -->
    <div class="d-flex">
      <base-text
        semibold
        class="summary-text"
      >
        Link:
      </base-text>
      &nbsp;
      <base-text class="summary-text cursor-pointer" @click="onLinkClicked(appointment)">
        {{ appointment.join_link ? appointment.join_link : appointment.invite_link }}
      </base-text>
    </div>
  </div>
</template>

<script>
export default {

  name: 'AppointmentReportSummary',
  props: {
    appointment: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onLinkClicked(appointment) {
      const link = appointment.join_link ? appointment.join_link : appointment.invite_link;
      this.$mixpanel.track('appointment_link', {
        location: '/appointment/report',
        url: link,
        account_id: this.$store.state.account.user.user.email,
      });
      window.open(link, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.summary-container {
  border: 1px solid #AAAAAA;
  padding: 20px;
}
.summary-text {
  font-size: 16px;
  color: #646464;
}
</style>
